// extracted by mini-css-extract-plugin
module.exports = {"block":"e_fW","heading":"e_gW"};